"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWITCH = void 0;
const colors_1 = require("../styles/colors");
exports.SWITCH = {
    styleOverrides: {
        switchBase: {
            // Controls default (unchecked) color for the thumb
            color: colors_1.$grey80,
        },
        colorPrimary: {
            '&.Mui-checked': {
                // Controls checked color for the thumb
                color: colors_1.$primaryBrand,
            },
        },
        colorSecondary: {
            '&.Mui-checked': {
                color: colors_1.$primaryNavy,
            },
            '&.Mui-checked + .MuiSwitch-track': {
                backgroundColor: colors_1.$grey10,
            },
            '&.Mui-checked.Mui-disabled': {
                color: colors_1.$primaryNavy,
                opacity: 0.5,
            },
        },
        track: {
            backgroundColor: colors_1.$grey10,
            '.Mui-checked.Mui-checked + &': {
                // Controls checked color for the track
                backgroundColor: colors_1.$grey10,
            },
        },
    },
};
